module.exports = __webpack_public_path__ + "static/img/scientific_img_one.8b11150a.png";